<script setup>

import {Form} from "vee-validate"
import InputField from "~/components/forms/subelements/InputField.vue"
import * as yup from "yup"
import {useNotification} from "~/composables/useNotification"
import {useAuthApi} from "~/composables/api/useAuthApi"
import {useAuthStore} from "~/store/auth"
import Button from "~/components/common/Button.vue"

const emit = defineEmits(['login-success'])

const props = defineProps({
  autofocus: {
    type: Boolean,
    default: () => false
  },
  showCreateAccountBtn: {
    type: Boolean,
    default: () => true
  },
  showForgotPasswordBtn: {
    type: Boolean,
    default: () => true
  }
})

const config = useRuntimeConfig()
const router = useRouter()
const route = useRoute()
const notification = useNotification()
const authApi = useAuthApi()
const authStore = useAuthStore()
const sending = ref(false)
const loginData = ref({
  email: config.public.pricingTableUser,
  password: ''
})

const loginSchema = yup.object({
  email: yup.string().required().email().label('Correo Electrónico'),
  password: yup.string().required().min(6).max(20).label('Contraseña')
})

async function onSubmit() {
  try {
    if (sending.value) return
    sending.value = true

    const response = await authApi.login(loginData.value.email, loginData.value.password)
    await authStore.setPriceToken(response.token)

    sending.value = false
    const detail = `Acceso correcto`
    notification.showSecondary(detail)

    emit('login-success')
  } catch (error) {
    console.error(error)
    sending.value = false
    notification.showError(error)
  }
}

onMounted(() => {
  if (props.autofocus) {
    setTimeout(() => {
      document.getElementById('email').focus()
    }, 200)
  }
})
</script>

<template>
  <div class="">
    <Form
      id="priceTableLoginForm"
      :validation-schema="loginSchema"
      @submit="onSubmit"
      class="grid grid-cols-12 px-4 xl:px-8 gap-4"
    >
      <InputField
        class="col-span-12"
        label="Correo Electrónico"
        type="hidden"
        inputId="email"
        name="email"
        v-model="loginData.email"
        placeholder="Introduce tu correo electrónico"
      />

      <InputField
        class="col-span-12"
        label="Contraseña"
        type="password"
        inputId="password"
        name="password"
        v-model="loginData.password"
        placeholder="Introduce tu contraseña"
      />

      <div class="col-span-12 text-center xl:text-right mb-5">
        <Button
          :loading="sending"
          label="Acceder"
          type="submit"
        />
      </div>
    </Form>
  </div>
</template>
